import { Image as ImageIcon, ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AddToCartButton } from '@/components/orders/AddToCartButton';

type Props = {
  onAddToCart: () => void;
  onManageAssets: () => void;
  onOpen: () => void;
  isAddingToCart?: boolean;
  isInCart?: boolean;
  /** Manage assets is hidden when the property has no delivered photoset. */
  hasPhotoset?: boolean;
};

export const DrawerActionRow = ({
  onAddToCart,
  onManageAssets,
  onOpen,
  isAddingToCart = false,
  isInCart = false,
  hasPhotoset = false,
}: Props) => (
  <div className="flex items-center gap-2">
    <AddToCartButton
      idleVariant="default"
      isAdding={isAddingToCart}
      isAdded={isInCart}
      onAddToCart={onAddToCart}
      className="flex-1"
      data-testid="drawer-add-to-cart"
    />
    {hasPhotoset && (
      <Button
        variant="outline"
        onClick={onManageAssets}
        data-testid="drawer-manage-assets"
      >
        <ImageIcon className="h-4 w-4" />
        Manage Assets
      </Button>
    )}
    <Button
      variant="outline"
      size="icon"
      onClick={onOpen}
      aria-label="Open Property"
      data-testid="drawer-open"
    >
      <ArrowUpRight className="h-4 w-4" />
    </Button>
  </div>
);
